import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Campaign Reachout", -1);
var _hoisted_2 = {
  "class": "mb-8"
};
var _hoisted_3 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")])], -1);
var _hoisted_5 = {
  "class": "px-2 pb-4"
};
var _hoisted_6 = {
  "class": "px-2 pb-4"
};
var _hoisted_7 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_text_input = _resolveComponent("text-input");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Campaigns"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, "Last updated: " + _toDisplayString($props.lastUpdated), 1), _createElementVNode("table", _hoisted_3, [_hoisted_4, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_5, [_createVNode(_component_text_input, {
    modelValue: $data.search,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.search = $event;
    }),
    type: "text"
  }, null, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_6, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.search = '';
    })
  }, "Reset")])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_table, {
    data: $options.filterTableData,
    stripe: "",
    style: {
      "width": "100%"
    },
    height: "350",
    "default-sort": {
      prop: 'tenant_id',
      order: 'ascending'
    }
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "tenant_id",
        label: "Tenant",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "campaign_data",
        label: "Campaigns",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "contacts",
        label: "Contacts",
        sortable: ""
      }, {
        "default": _withCtx(function (scope) {
          return [scope.row.contacts > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.contacts.toLocaleString("en-US")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(scope.row.contacts), 1))];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "companies",
        label: "Companies",
        sortable: ""
      }, {
        "default": _withCtx(function (scope) {
          return [scope.row.companies > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.companies.toLocaleString("en-US")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(scope.row.companies), 1))];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "contacts_touchbase",
        label: "TouchBase",
        sortable: ""
      }, {
        "default": _withCtx(function (scope) {
          return [scope.row.contacts_touchbase > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(scope.row.contacts_touchbase.toLocaleString("en-US")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.row.contacts_touchbase), 1))];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "contacts_bounced",
        label: "Bounced",
        sortable: ""
      }, {
        "default": _withCtx(function (scope) {
          return [scope.row.contacts_bounced > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.contacts_bounced.toLocaleString("en-US")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.contacts_bounced), 1))];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "delivery_percent",
        label: "Delivery % ",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "bounce_percent",
        label: "Bounce % ",
        sortable: ""
      })];
    }),
    _: 1
  }, 8, ["data"])])]);
}